import React, { type MouseEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import ArrowCurvedUpLeftIcon from '@atlaskit/icon-lab/core/arrow-curved-up-left';

import { usePageContentId } from '@confluence/page-context';
import { useAnnotationsIsOffline } from '@confluence/annotation-provider-store/entry-points/AnnotationsContext';
import { useAddCommentPermissionCheck } from '@confluence/comments-hooks/entry-points/useAddCommentPermissionCheck';

const messages = defineMessages({
	reply: {
		id: 'comments-common.comments.replies.footer.reply',
		defaultMessage: 'Reply',
		description: 'Label for the button to reply to a comment',
	},
});

type ReplyButtonProps = {
	handleReplyButtonClick: (event: MouseEvent<HTMLButtonElement>) => void;
	isParentCommentOpen: boolean;
	isStandaloneComment: boolean;
};

export const ReplyButton = ({
	handleReplyButtonClick,
	isParentCommentOpen,
	isStandaloneComment,
}: ReplyButtonProps) => {
	const { formatMessage } = useIntl();
	const isOffline = useAnnotationsIsOffline();

	const [contentId = ''] = usePageContentId();
	const { canAddComments } = useAddCommentPermissionCheck(contentId);

	if (!canAddComments || !isParentCommentOpen || isStandaloneComment) {
		return null;
	}

	return (
		<Button
			appearance="subtle"
			isDisabled={isOffline}
			onClick={handleReplyButtonClick}
			iconBefore={ArrowCurvedUpLeftIcon}
		>
			{formatMessage(messages.reply)}
		</Button>
	);
};
